/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export interface LinkedInConnectionRequestStepOverride {
  type: 'linkedin_connection_request';
  linkedin_invitation_note?: string | null;
}
